import { render, staticRenderFns } from "./UserChatTab.vue?vue&type=template&id=671bc55d&scoped=true&"
import script from "./UserChatTab.vue?vue&type=script&lang=js&"
export * from "./UserChatTab.vue?vue&type=script&lang=js&"
import style0 from "./UserChatTab.vue?vue&type=style&index=0&id=671bc55d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671bc55d",
  null
  
)

export default component.exports